import axios from 'axios'

const host = window.config.apiUrl

window.cancelTokens = []
window.whitelistedApiEndpoints = ['location/getreportkpi', 'other/endpoint']

// Add request interceptor
axios.interceptors.request.use(
  config => {
    // Add token to request
    if (typeof localStorage.token !== 'undefined') {
      config.headers['Authorization'] = 'Bearer ' + localStorage.token
    }

    // Do not include whitelisted api endpoints to cancelTokens
    if (
      window.whitelistedApiEndpoints.some((el, i, a) => {
        return config.url.includes(el)
      })
    ) {
      return config
    }

    // Create CancelToken (Only 'get' requests)
    if (config.method === 'get') {
      var source = axios.CancelToken.source()

      // Append 'cancelToken' and 'cancelTokenId' to the request
      config.cancelToken = source.token
      config.cancelTokenId = Math.trunc(Math.random() * 10000000000000000)

      // Add 'cancelToken' and 'cancelTokenId' to localStorage cancelTokens object, so we can search by its id and cancel it later if needed
      window.cancelTokens[config.cancelTokenId] = source.cancel
    }

    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add response interceptors
axios.interceptors.response.use(
  response => {
    // Remove request's cancelToken
    delete window.cancelTokens[response.config.cancelTokenId]
    return response
  },
  error => {
    // TODO: Are we logging these errors?
    // console.error(`Error from interceptor: ${error}`)
    // console.error(`Error from interceptor: ${JSON.stringify(error.response)}`)
    // console.error(`Error from interceptor: ${JSON.stringify(error.request)}`)
    // console.error(`Error from interceptor: ${error.message}`)
    // console.error(`Error from interceptor: ${JSON.stringify(error.config)}`)
    return Promise.reject(error)
  }
)

// Axios Common Base Instance (resource: https://goo.gl/sDN0IN)
export default {
  get: (endpoint, data = {}) => {
    return axios.get(`${host}${endpoint}`, data)
  },
  post: (endpoint, data = {}, config = {}) => {
    return axios.post(`${host}${endpoint}`, data, config)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/api.js